import { RECEIPT_FETCH_REQUEST, RECEIPT_FETCH_SUCCESS, RECEIPT_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    receipt: {},
    error: ''
}

const receipt = (state = initialState, action) => {
    switch (action.type) {
        case RECEIPT_FETCH_REQUEST:
            return {
                loading: true,
                receipt: {},
                error: '',
            }
        case RECEIPT_FETCH_SUCCESS:
            return {
                loading: false,
                receipt: action.payload,
                error: ''
            }
        case RECEIPT_FETCH_FAILURE:
            return {
                loading: false,
                receipt: {},
                error: action.payload
            }
        default: return state
    }
}

export default receipt;